import React from 'react';
import { Route } from 'react-router';

import WeaPortalNoRight from './wea-portal-noright';
import WeaAddNotice from './wea-addnotice';
import WeaMaterialLib from './wea-materiallib';
import MaterialLib from './wea-materiallib/MaterialLib';
import WeaFavourite from './wea-favourite';
import WeaPlugin from './wea-plugin';
import WeaLicense from './wea-license';
import WeaLicenseSubmit from './wea-license-submit';
import WeaVersion from './wea-version';
import WeaSystemSetting from './wea-system-setting';
import WeaThemeCenter from './wea-theme-center';
import WeaThemeLayout from './wea-theme-layout';
import WeaNonStandard from './wea-non-standard';
import WeaPortalShare from './wea-portal-share';
import WeaPortalAlert from './wea-portal-alert';
import WeaPortalLayout from './wea-portal-layout';
import WeaExportElements from './wea-protal-exele';
import WeaElementPreview from './wea-element-preview';
import WeaMenu from './wea-menu'

module.exports = {
  Route: [],
  WeaPortalNoRight,
  WeaAddNotice,
  WeaMaterialLib,
  MaterialLib,
  WeaFavourite,
  WeaPlugin,
  WeaLicense,
  WeaLicenseSubmit,
  WeaVersion,
  WeaSystemSetting,
  WeaThemeCenter,
  WeaThemeLayout,
  WeaNonStandard,
  WeaPortalShare,
  WeaPortalAlert,
  WeaPortalLayout,
  WeaExportElements,
  WeaElementPreview,
  WeaMenu
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/index.js